import { ITooltip, Text } from '@components';
import {
  cleanProductStatus,
  ProductStatus,
  ProductStatusTooltips,
} from '@models/Product.model';
import { ProductStatusIcon } from '@components/ProductStatusIcon';
import { CSSObject, Group, Stack } from '@mantine/core';
import { lengthFromDays } from '@utils/time/lengthFromDays';
import { DataLink } from './Data.styles';
import { IDataItem } from './types';

const PRODUCT_STATUS: CSSObject = {
  '.i__tooltip': {
    textAlign: 'left',
  },

  '.i__tooltip svg': {
    fill: 'white',
    color: 'white',
  },
};
export const Items: IDataItem[] = [
  {
    fieldName: 'productName',
  },
  {
    fieldName: 'productModel', // imported fields are handled at the model level.
  },
  {
    fieldName: 'productStatus',
    formatter(value) {
      if (typeof value !== 'string') return null;
      const tValue = value as ProductStatus;
      const cleanValue = cleanProductStatus(tValue);
      // Todo: Clean the "IconAndName" setup of productStatus. Or Extract this layout into TooltipBody
      const IconAndName = (
        <Stack spacing={6}>
          <Group spacing={8}>
            <ProductStatusIcon status={tValue} />
            <Text text="b200" tt="capitalize" c="inherit">
              {cleanValue}
            </Text>
          </Group>
          <Text text="b200" c="inherit">
            {ProductStatusTooltips[tValue]}
          </Text>
        </Stack>
      );

      return (
        <Group
          data-tip="tip"
          data-for="productStatusTooltip"
          spacing={8}
          sx={PRODUCT_STATUS}
        >
          <ProductStatusIcon status={tValue} />
          <Text text="p200" tt="capitalize">
            {cleanValue}
          </Text>
          <ITooltip id="productStatusTooltip">{IconAndName}</ITooltip>
        </Group>
      );
    },
  },
  {
    fieldName: 'productWarranty',
    formatter(value) {
      if (typeof value !== 'number') return null;
      return lengthFromDays(value);
    },
  },
  {
    fieldName: 'productCategory',
  },
  {
    fieldName: 'productPage',
    formatter(...args) {
      const [productPage] = args;
      if (typeof productPage !== 'string') return null;
      const hideLink = productPage.includes('bhphotovideo');
      if (hideLink) return null;
      return (
        <DataLink href={productPage} target="_blank" rel="noopener noreferrer">
          Link
        </DataLink>
      );
    },
  },
  {
    fieldName: 'manufacturerName', // imported fields are handled at model level.
  },
  {
    fieldName: 'productDescription',
    customName: 'Description',
  },
];
